module.exports = __webpack_public_path__ + "img/Image -4.5584bd23.svg";